import type {
  CareCreditChipStatus,
  CareCreditPatientData,
  CareCreditPatientStatus,
} from '@frontend/payments-care-credit';

type CareCreditPaymentMethodStateInput = {
  careCreditData?: Pick<CareCreditPatientData, 'status'>;
  careCreditChipStatus?: CareCreditChipStatus;
  isApplicationDeclined: boolean;
};

export const getCareCreditPaymentMethodState = ({
  careCreditData,
  careCreditChipStatus,
  isApplicationDeclined,
}: CareCreditPaymentMethodStateInput) => {
  const applicantStatus = careCreditData?.status;
  const statusWithErrors: CareCreditPatientStatus | 'ERROR' | undefined = careCreditChipStatus ?? applicantStatus;
  const isUnknown = statusWithErrors === 'UNKNOWN';

  return {
    applicantStatus,
    isUnknown,
    isDisabledByStatus: isApplicationDeclined || statusWithErrors === 'ERROR',
    chipStatus: statusWithErrors,
    statusWithErrors,
  };
};
